import { instance } from "apis/interceptor";
import { ResponseType } from "apis/meetings/meeting-reservation";

type TVisitorsModalMetaData = {
  onboardingModalDismissed: boolean;
  updateModalDismissed: boolean;
  connectPersonalCalendarModalDismissed: boolean;
  detectPersonalCalendarModalDismissed: boolean;
};

//* 방문자 모달 메타데이터 조회
export const getVisitorsModalMetaData = async (): Promise<ResponseType<TVisitorsModalMetaData>> => {
  try {
    const res = await instance.get("/visitors/modal");
    return { data: res.data, success: true };
  } catch (error) {
    return { success: false };
  }
};

//* 방문자 모달 온보딩 모달 닫기
export const updateVisitorsOnboardingModalDismissed = async (): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/visitors/modal/onboarding");
    return { success: res.data.result };
  } catch (error) {
    return { success: false };
  }
};
